import { RefObject } from 'react';

export function isReferenceDefined(
    reference: RefObject<HTMLElement>,
    event: MouseEvent | TouchEvent
): boolean {
    return (reference.current &&
        !reference.current.contains(event.target as HTMLElement)) as boolean;
}
